import moment from 'moment';
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { getProviderAccountsRefreshing, getSelectedProviderId, getSyncedProviderAccountIds, getSyncedProviderAccounts } from "../selectors";
import { readYodleeProfile } from "../actions/profiles";
import { deleteProviderAccount, getCashFlowProjection, getCategoryWindowRollups, getDailyTransactionsCashFlow, getNextTransactionsPage, getTopMerchants, getTransactionsMonthCashFlow, loginToProvider, refreshProviderAccount, resetTransactions, selectProviderAccount } from "../actions/yodlee";
import { TOP_MERCHANTS_REQUEST_LIMIT } from "../constants/yodlee";
import { DATE_FORMAT } from "../constants";
import { yodlee as yodleeUtils } from "../utils";
/**
 * Fetches new transaction data whenever a provider status changes to or from `ACTIVE`.
 *
 * Updates the provider account as part of the onboarding on a login success iff it is the currently selected provider.
 * During the onboarding process of linking accounts, the providerId in onboarding is updated with the selected
 * provider and after a successful login, the providerAccountId is updated. When accounts are linked asynchronously,
 * it is possible for a successful login to return the providerAccountId while the user is linking another account,
 * resulting in a mismatch between the providerId and providerAccountId
 *
 * @name providerAccountsMiddleware
 * @type ReduxMiddleware
 */

export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      if (!process.browser) return next(action);
      var prevState = getState();
      var prevProviders = getSyncedProviderAccounts(prevState.identity);
      var prevProviderIds = getSyncedProviderAccountIds(prevState.identity);
      var prevRefreshingProviders = getProviderAccountsRefreshing(prevState.identity);
      var returnValue = next(action);
      var state = getState();
      var nextProviders = getSyncedProviderAccounts(state.identity);
      var nextProviderIds = getSyncedProviderAccountIds(state.identity);
      var nextRefreshingProviders = getProviderAccountsRefreshing(state.identity);

      if (action.type === loginToProvider.SUCCESS_TYPE) {
        var providerId = getSelectedProviderId(state.identity);

        if (providerId === action.payload.provider_id) {
          dispatch(selectProviderAccount(action.payload.provider_account_id));
        }
      }

      var isRefreshFailure = action.type === refreshProviderAccount.FAIL_TYPE;
      var shouldUpdate = action.type === deleteProviderAccount.SUCCESS_TYPE || yodleeUtils.getHaveProviderAccountsChangedOrRefreshed(prevProviders, nextProviders, prevProviderIds, nextProviderIds, isRefreshFailure, prevRefreshingProviders, nextRefreshingProviders);

      if (shouldUpdate) {
        var formattedToday = moment().format(DATE_FORMAT.STANDARD);
        dispatch(readYodleeProfile());
        dispatch(resetTransactions());
        dispatch(getNextTransactionsPage());
        dispatch(getDailyTransactionsCashFlow({
          dayInTargetMonth: formattedToday
        }));
        dispatch(getTransactionsMonthCashFlow({
          dayInTargetMonth: formattedToday
        }));
        dispatch(getCategoryWindowRollups({
          startDate: moment().startOf('month').format(DATE_FORMAT.STANDARD),
          endDate: moment().endOf('month').format(DATE_FORMAT.STANDARD)
        }));
        dispatch(getTopMerchants({
          startDate: moment().subtract(30, 'days').format(DATE_FORMAT.STANDARD),
          endDate: formattedToday,
          includeSlices: [NwApiSDK.IDENTITY_TRANSACTION_SLICES.WINDOW],
          limit: TOP_MERCHANTS_REQUEST_LIMIT
        }));
        dispatch(getCashFlowProjection({
          dayInTargetMonth: formattedToday
        }));
      }

      return returnValue;
    };
  };
});